module.exports = __webpack_public_path__ + "static/media/wx1.cf40f28e.png";